import ButtonComponent from '@/components/ButtonComponent';
import { formatComma } from '@/utils/form';
import styled from 'styled-components';
import theme from '@/styles/theme';

interface Props {
  price: string | number;
  onSubmitSetPrice: () => void;
  onCloseModal: () => void;
}
const PriceConfirmModal = ({
  price,
  onSubmitSetPrice,
  onCloseModal
}: Props) => {
  return (
    <ModalWrapper>
      <ModalTop>
        <Title>
          <span>{formatComma(Number(price))}원</span> 결제를 요청할까요?
        </Title>
        <Content>
          가격을 정확히 입력했는지{'\n'}
          다시 한 번 확인해주세요.
        </Content>
      </ModalTop>
      <ModalBottom>
        <ButtonComponent
          borderColor={theme.DF_COLOR.WHITE}
          bgColor={theme.DF_COLOR.WHITE}
          textColor={theme.DF_COLOR.GRAY700}
          text={'취소'}
          padding={'1rem'}
          onClick={onCloseModal}
        />
        <ModalButtonDivision />
        <ButtonComponent
          borderColor={theme.DF_COLOR.WHITE}
          bgColor={theme.DF_COLOR.WHITE}
          textColor={theme.DF_COLOR.PRIMARY600}
          text={'확인'}
          padding={'1rem'}
          onClick={onSubmitSetPrice}
        />
      </ModalBottom>
    </ModalWrapper>
  );
};

export default PriceConfirmModal;

const ModalWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;

const ModalTop = styled.div`
  padding: 40px;
  width: 480px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const Title = styled.div`
  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI26B};
    color: ${theme.DF_COLOR.GRAY700};

    span {
      color: ${theme.DF_COLOR.PRIMARY600};
    }
  `};
`;
const Content = styled.div`
  white-space: pre-wrap;

  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI20R};
    color: ${theme.DF_COLOR.GRAY500};
  `};
`;

const ModalBottom = styled.div`
  width: 100%;
  text-align: center;
  cursor: pointer;
  display: flex;

  > * {
    &:nth-child(odd) {
      flex: 1;
    }
  }
  ${({ theme }) => `
    border-top: 1px solid ${theme.DF_COLOR.GRAY100};
  `};
`;

const ModalButtonDivision = styled.div`
  width: 1px;
  margin: 0 1px;
  ${({ theme }) => `
    background: ${theme.DF_COLOR.GRAY100};
  `};
`;
